// Service detail data - separated to avoid babel plugin issues
export const serviceImages = {
  "residential-painting": {
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1260&q=80"
  },
  "remodeling-renovations": {
    image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=1260&q=80"
  },
  "drywall-repair": {
    image: "https://images.unsplash.com/photo-1766961980272-921bba4240bc?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1766961980272-921bba4240bc?w=1260&q=80"
  },
  "carpentry": {
    image: "https://images.pexels.com/photos/8031949/pexels-photo-8031949.jpeg?w=800&q=80",
    heroImage: "https://images.pexels.com/photos/8031949/pexels-photo-8031949.jpeg?w=1260&q=80"
  },
  "tile-installation": {
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1260&q=80"
  },
  "exterior-siding": {
    image: "https://images.unsplash.com/photo-1698175944396-9c6535d13741?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1698175944396-9c6535d13741?w=1260&q=80"
  },
  "deck-construction": {
    image: "https://images.unsplash.com/photo-1716904519810-349244919824?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1613544723412-b331bda01e87?w=1260&q=80"
  },
  "mold-remediation": {
    image: "https://images.unsplash.com/photo-1721942363902-18f9aeb63834?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1721942363902-18f9aeb63834?w=1260&q=80"
  },
  "parking-lot-striping": {
    image: "https://images.unsplash.com/photo-1697981027675-3770d1b8ee6d?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1546081090-054f9f0ce0d9?w=1260&q=80"
  },
  "brick-masonry": {
    image: "https://images.unsplash.com/photo-1737093351158-81a918125889?w=800&q=80",
    heroImage: "https://images.pexels.com/photos/1369118/pexels-photo-1369118.jpeg?w=1260&q=80"
  },
  "roof-repairs": {
    image: "https://images.unsplash.com/photo-1553169507-38833977274b?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1681049400158-0ff6249ac315?w=1260&q=80"
  }
};

export const serviceDescriptions = {
  "residential-painting": "Professional interior and exterior painting services for Dallas homes. Transform your space with high-quality finishes that last.",
  "remodeling-renovations": "Complete home renovation services in Dallas. From kitchen and bathroom remodels to whole-home transformations.",
  "drywall-repair": "Expert drywall services in Dallas. From small repairs to full installations with seamless texture matching.",
  "carpentry": "Custom carpentry and woodwork in Dallas. From trim work to custom built-ins, we bring craftsmanship to every project.",
  "tile-installation": "Professional tile installation in Dallas. Kitchens, bathrooms, floors, and backsplashes with precision craftsmanship.",
  "exterior-siding": "Durable siding installation and repair in Dallas. Protect your home from Texas weather with quality siding solutions.",
  "deck-construction": "Custom deck building in Dallas. Create the perfect outdoor living space with quality materials and expert construction.",
  "mold-remediation": "Professional mold removal in Dallas. Licensed experts safely eliminate mold and restore your home to healthy conditions.",
  "parking-lot-striping": "Professional parking lot striping, seal coating, and asphalt repair in Dallas. ADA-compliant markings, fire lane painting, and new layout designs for commercial and multi-family properties.",
  "brick-masonry": "Expert brick and masonry services in Dallas. From brick ties and mortar repairs to stonework, fireplaces, mailboxes, stucco, and decorative stone landscaping edging.",
  "roof-repairs": "Reliable roof repairs and exterior leak solutions in Dallas. Comprehensive waterproof sealing, leak detection, and protective repairs to safeguard your property from water damage."
};

export const serviceFeatures = {
  "residential-painting": [
    "Interior wall and ceiling painting",
    "Exterior house painting",
    "Cabinet refinishing",
    "Trim, doors, and window painting",
    "Deck and fence staining",
    "Color consultation services"
  ],
  "remodeling-renovations": [
    "Kitchen remodeling",
    "Bathroom renovations",
    "Basement finishing",
    "Room additions",
    "Open floor plan conversions",
    "Custom cabinetry installation"
  ],
  "drywall-repair": [
    "Hole and crack repairs",
    "Water damage restoration",
    "New drywall installation",
    "Texture matching",
    "Ceiling repairs",
    "Popcorn ceiling removal"
  ],
  "carpentry": [
    "Crown molding installation",
    "Baseboard and trim work",
    "Custom shelving and built-ins",
    "Door installation and repair",
    "Window trim and casing",
    "Wainscoting and paneling"
  ],
  "tile-installation": [
    "Kitchen backsplash installation",
    "Bathroom floor and wall tile",
    "Shower and tub surrounds",
    "Floor tile installation",
    "Outdoor tile and pavers",
    "Tile repair and replacement"
  ],
  "exterior-siding": [
    "Vinyl siding installation",
    "Fiber cement siding",
    "Wood siding repair",
    "Siding replacement",
    "Trim and fascia work",
    "Soffit installation"
  ],
  "deck-construction": [
    "Custom deck design",
    "Wood deck construction",
    "Composite decking",
    "Deck repairs and restoration",
    "Railing installation",
    "Pergola and cover additions"
  ],
  "mold-remediation": [
    "Mold inspection and testing",
    "Complete mold removal",
    "Black mold remediation",
    "Water damage restoration",
    "Air quality improvement",
    "Prevention treatments"
  ],
  "parking-lot-striping": [
    "Parking lot restriping to refresh faded lines",
    "ADA-compliant striping for accessibility",
    "New layout striping for commercial properties",
    "Multi-family parking lot markings",
    "Fire lane painting to meet local codes",
    "Seal coating and asphalt repair"
  ],
  "brick-masonry": [
    "Brick ties and structural repairs",
    "Brickwork and tuckpointing",
    "Fireplace construction and repair",
    "Stonework and stone veneer",
    "Mailbox construction and repair",
    "Stone landscaping edging",
    "Stucco application and repair",
    "Mortar joint repairs"
  ],
  "roof-repairs": [
    "Roof leak detection and repair",
    "Shingle replacement and repair",
    "Exterior waterproof sealing",
    "Flashing repairs",
    "Gutter-related leak repairs",
    "Skylight leak repairs"
  ]
};

export const serviceBenefits = {
  "residential-painting": [
    "Boost curb appeal and property value",
    "Protect surfaces from weather damage",
    "Create the perfect atmosphere",
    "Long-lasting professional finish"
  ],
  "remodeling-renovations": [
    "Increase home value significantly",
    "Modernize outdated spaces",
    "Improve functionality and flow",
    "Customize to your lifestyle"
  ],
  "drywall-repair": [
    "Restore walls to perfect condition",
    "Seamless repairs that blend perfectly",
    "Prepare surfaces for painting",
    "Fix damage from water or impacts"
  ],
  "carpentry": [
    "Add architectural detail to any room",
    "Increase home value with custom features",
    "Improve functionality with built-ins",
    "Quality craftsmanship that lasts"
  ],
  "tile-installation": [
    "Durable, water-resistant surfaces",
    "Easy to clean and maintain",
    "Endless design possibilities",
    "Increase home value"
  ],
  "exterior-siding": [
    "Protect from weather damage",
    "Improve energy efficiency",
    "Boost curb appeal dramatically",
    "Low maintenance options"
  ],
  "deck-construction": [
    "Expand outdoor living space",
    "Increase property value",
    "Perfect for entertaining",
    "Custom designed for your home"
  ],
  "mold-remediation": [
    "Protect your family's health",
    "Prevent structural damage",
    "Eliminate musty odors",
    "Licensed and certified process"
  ],
  "parking-lot-striping": [
    "Improve safety and traffic flow",
    "Ensure ADA compliance",
    "Enhance property appearance",
    "Meet local fire codes"
  ],
  "brick-masonry": [
    "Restore structural integrity",
    "Enhance curb appeal",
    "Increase property value",
    "Weather-resistant repairs"
  ],
  "roof-repairs": [
    "Prevent costly water damage",
    "Extend roof lifespan",
    "Protect home interior",
    "Quick emergency response"
  ]
};

export const serviceFAQs = {
  "residential-painting": [
    { q: "How long does interior painting take?", a: "Most rooms take 1-2 days. A full home typically takes 3-7 days depending on size and prep work needed." },
    { q: "What paint brands do you use?", a: "We use premium brands like Sherwin-Williams, Benjamin Moore, and Behr for lasting quality." },
    { q: "Do you move furniture?", a: "Yes, we handle moving and covering furniture, and protect your floors with drop cloths." }
  ],
  "remodeling-renovations": [
    { q: "How long does a kitchen remodel take?", a: "A typical kitchen remodel takes 4-8 weeks depending on scope. We provide detailed timelines during planning." },
    { q: "Do I need permits for renovation?", a: "Most structural changes require permits. We handle all permitting as part of our service." },
    { q: "Can I stay home during remodeling?", a: "In most cases, yes. We work to minimize disruption and maintain clean, safe work areas." }
  ],
  "drywall-repair": [
    { q: "Can you match my existing texture?", a: "Yes, we're experts at matching all common Texas textures including knockdown, orange peel, and smooth." },
    { q: "How do you fix water-damaged drywall?", a: "We remove damaged sections, treat for mold if needed, install new drywall, and finish to match." },
    { q: "How long does drywall repair take?", a: "Small repairs take a few hours. Larger areas need 2-3 days including drying time between coats." }
  ],
  "carpentry": [
    { q: "What type of wood do you recommend?", a: "It depends on the project. We often use oak, poplar, and MDF for trim, and hardwoods for custom pieces." },
    { q: "Can you match existing trim styles?", a: "Absolutely. We can replicate existing profiles or help you choose complementary styles." },
    { q: "Do you do custom built-ins?", a: "Yes, we design and build custom shelving, entertainment centers, and storage solutions." }
  ],
  "tile-installation": [
    { q: "What tile is best for bathrooms?", a: "Porcelain and ceramic tiles are ideal for bathrooms due to water resistance." },
    { q: "How long does tile installation take?", a: "A bathroom floor typically takes 2-3 days. Kitchen backsplashes usually take 1-2 days." },
    { q: "Can you remove old tile?", a: "Yes, we handle complete tear-out and disposal of existing tile before new installation." }
  ],
  "exterior-siding": [
    { q: "What siding is best for Texas weather?", a: "Fiber cement and vinyl siding perform excellently in Texas, handling heat, humidity, and storms." },
    { q: "How long does siding last?", a: "Quality vinyl lasts 20-40 years. Fiber cement can last 50+ years with proper maintenance." },
    { q: "Can you repair storm damage?", a: "Yes, we repair all types of storm damage including hail, wind, and impact damage." }
  ],
  "deck-construction": [
    { q: "Wood or composite decking?", a: "Composite costs more upfront but requires less maintenance. Wood is traditional but needs regular staining." },
    { q: "Do I need a permit for a deck?", a: "Most deck projects in Dallas require permits. We handle all permitting as part of our service." },
    { q: "How long does deck construction take?", a: "A typical deck takes 1-2 weeks. Larger or more complex designs may take 3-4 weeks." }
  ],
  "mold-remediation": [
    { q: "How do I know if I have mold?", a: "Signs include musty odors, visible growth, water stains, and allergy symptoms. We offer professional inspections." },
    { q: "Is mold dangerous?", a: "Yes, mold can cause respiratory issues and other health problems. Black mold is particularly dangerous." },
    { q: "Will mold come back?", a: "Not if we address the moisture source. We identify and help fix underlying water issues." }
  ],
  "parking-lot-striping": [
    { q: "How often should parking lots be restriped?", a: "Typically every 18-24 months, depending on traffic volume and weather exposure. High-traffic areas may need more frequent restriping." },
    { q: "What is ADA-compliant striping?", a: "ADA-compliant striping includes accessible parking spaces, access aisles, and proper signage that meet Americans with Disabilities Act requirements." },
    { q: "How long does parking lot striping take?", a: "Most parking lots can be completed in 1-2 days. Paint typically dries within 30 minutes to 1 hour depending on conditions." }
  ],
  "brick-masonry": [
    { q: "What are brick ties?", a: "Brick ties are metal connectors that secure brick veneer to the structural wall, essential for stability and longevity of brick exteriors." },
    { q: "How do you repair mortar joints?", a: "We use tuckpointing to remove damaged mortar and replace it with fresh mortar that matches your existing color and style." },
    { q: "Can you match existing brick?", a: "Yes, we have extensive experience matching brick colors, sizes, and patterns for seamless repairs and additions." }
  ],
  "roof-repairs": [
    { q: "How do I know if my roof is leaking?", a: "Look for water stains on ceilings, peeling paint, musty odors, or visible damage to shingles. We offer free inspections to identify issues." },
    { q: "Can you repair just the damaged area?", a: "Yes, in most cases we can repair specific areas without replacing the entire roof, saving you significant costs." },
    { q: "Do you offer emergency roof repair?", a: "Yes, we provide emergency services for storm damage and active leaks to protect your home from further damage." }
  ]
};

export const serviceProcess = [
  { step: 1, title: "Free Consultation", desc: "We assess your space and discuss your needs" },
  { step: 2, title: "Detailed Quote", desc: "Transparent pricing with no hidden fees" },
  { step: 3, title: "Preparation", desc: "Proper prep work for quality results" },
  { step: 4, title: "Expert Work", desc: "Professional execution by skilled craftsmen" },
  { step: 5, title: "Final Walkthrough", desc: "Ensure 100% satisfaction" }
];
